import React from 'react'

export const InstagramIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="44.62" height="44.62" viewBox="0 0 44.62 44.62">
      <path id="instagram-icon" fill="#D7DF23" d="M0 0v44.62h44.62V0H0zm40.49 32.411c0 4.379-3.55 7.918-7.92 7.918H12.05c-4.37 0-7.92-3.539-7.92-7.918V12.209c0-4.381 3.55-7.93 7.92-7.93h20.52c4.37 0 7.92 3.549 7.92 7.93v20.202zM34.32 7.329c-1.53 0-2.77 1.24-2.77 2.771 0 1.529 1.239 2.77 2.77 2.77 1.521 0 2.76-1.24 2.76-2.77 0-1.531-1.239-2.771-2.76-2.771zM22.311 10.86C16 10.86 10.87 16 10.87 22.309c0 6.311 5.13 11.441 11.44 11.441s11.45-5.131 11.45-11.441C33.761 16 28.62 10.86 22.311 10.86zm0 18.779c-4.04 0-7.33-3.291-7.33-7.33s3.29-7.33 7.33-7.33 7.33 3.291 7.33 7.33-3.29 7.33-7.33 7.33z" />
    </svg>
  )
}
